import React, { useState, useEffect, useContext, useRef } from "react";
import RnDokumenta from "./RnDokumenta";
import { useHistory } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { AuthContext } from "../../Header/auth - context";
import { Checkbox } from "primereact/checkbox";
import { AutoComplete } from "primereact/autocomplete";
import { FileUpload } from "primereact/fileupload";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import usePermission from "../../custom/usePermission";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // <- mora biti renderovana
import { InputNumber } from "primereact/inputnumber";
import CustomDropdown from "../../custom/customDropdown";
import RutaVozaca from "./RutaVozaca";
import handlePrintWork from "./naloziStrane/radniNalogStampa";
import "primeicons/primeicons.css";
import "./Ture.css";

const RadniNalog = (props) => {
  const history = useHistory();
  const auth = useContext(AuthContext);
  const formRef = useRef(null);
  const toast = useRef(null);
  const trip = useSelector((state) => state.trip);
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const eskaliran = useSelector((state) => state.eskaliran);
  const userRole = useSelector((state) => state.user_role);
  const { can } = usePermission();
  const { t } = useTranslation();
  const [izabranRadni, setIzabranRadni] = useState(false);
  const [popuni, setPopuni] = useState(false);
  const [idWorkLog, setIdWorkLog] = useState(null);
  // Live status vozača/rute (tab VOZAČ) — isti podaci koje RutaVozaca već učitava
  // (RadniNalogVozacInit), samo prikazani direktno ispod napomene, ne skriveni
  // u dijalogu mape. Poluje se dok je tab VOZAČ otvoren da bude "live" bez
  // ručnog osvežavanja cele forme kad vozač promeni status sa telefona.
  const [statusVozacaInfo, setStatusVozacaInfo] = useState(null);
  const [filteredWorkLog, setFilteredWorkLog] = useState([]);
  const [radniNaloziDB, setRadniNaloziDB] = useState([]);
  const [klijentiOptions, setKlijentiOptions] = useState([]);
  const [zemljeOptions, setZemljeOptions] = useState([]);
  const [granicniPrelaziOptions, setGranicniPrelaziOptions] = useState([]);
  const [obracunKursaOptions, setObracunKursaOptions] = useState([]);
  const [valuteOptions, setValuteOptions] = useState([]);
  const [valuteEffectivaOptions, setValuteEffectivaOptions] = useState([]);
  const [kurseviDB, setKurseviDB] = useState([]);
  const [kurseviEffectivaDB, setKurseviEffectivaDB] = useState([]);
  const [tipNalogaOptions, setTipNalogaOptions] = useState([]);
  const [statusNalogaOptions, setStatusNalogaOptions] = useState([]);
  const [finansijskiStatusOptions, setFinansijskiStatusOptions] = useState([]);
  const [statusSefaOptions, setStatusSefaOptions] = useState([]);

  const [changeView, setChangeView] = useState(1);
  const activeClass = "activeButton";

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmittedInvoice, setFormSubmittedInvoice] = useState(false);

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const handleExportChange = (index, field, value) => {
    const updated = [...formDataShipmentExport];
    updated[index][field] = value;
    setFormDataShipmentExport(updated);
  };

  const addExport = () => {
    setFormDataShipmentExport([
      ...formDataShipmentExport,
      {
        datumUtovara: null,
        nazivPreduzecaUtovara: "",
        zemljaUtovara: null,
        postanskiBrojUtovara: "",
        gradUtovara: "",
        adresaUtovara: "",
        ADRRobaUtovara: null,
        vrstaRobeUtovara: "",
        napomenaUtovara: "",
        referentniBrojUtovara: "",
        brojPaletaUtovara: null,
        tezinaRobeUtovara: null,
        temperaturniRezimUtovara: "",
        napomenaIzvoz: "",
      },
    ]);
  };

  const removeExport = (index) => {
    if (formDataShipmentExport.length > 1) {
      setFormDataShipmentExport(
        formDataShipmentExport.filter((_, i) => i !== index)
      );
    }
  };

  // Saradnici
  const handleImportChange = (index, field, value) => {
    const updated = [...formDataShipmentImport];
    updated[index][field] = value;
    setFormDataShipmentImport(updated);
  };

  const addImport = () => {
    setFormDataShipmentImport([
      ...formDataShipmentImport,
      {
        nazivPreduzecaIstovara: "",
        datumIstovara: null,
        zemljaIstovara: null,
        postanskiBrojIstovara: "",
        gradIstovara: "",
        adresaIstovara: "",
        // Dodatni podaci o istovaru
        vrstaRobeIstovara: "",
        brojPaletaIstovara: null,
        tezinaRobeIstovara: null,
        referentniBrojIstovara: "",
        napomenaUvoz: "",
      },
    ]);
  };

  const removeImport = (index) => {
    if (formDataShipmentImport.length > 1) {
      setFormDataShipmentImport(
        formDataShipmentImport.filter((_, i) => i !== index)
      );
    }
  };

  ///DATA
  const [formDataShipmentExport, setFormDataShipmentExport] = useState([
    {
      ID: null,
      datumUtovara: null,
      nazivPreduzecaUtovara: "",
      zemljaUtovara: null,
      postanskiBrojUtovara: "",
      gradUtovara: "",
      adresaUtovara: "",
      ADRRobaUtovara: null,
      vrstaRobeUtovara: "",
      referentniBrojUtovara: "",
      brojPaletaUtovara: null,
      tezinaRobeUtovara: null,
      temperaturniRezimUtovara: "",
      napomenaIzvoz: "",
      vrednostRobe: null,
      vrednostRobeValuta: null,
    },
  ]);

  const [formDataShipmentImport, setFormDataShipmentImport] = useState([
    {
      ID: null,
      nazivPreduzecaIstovara: "",
      napomenaUvoz: "",
      datumIstovara: null,
      zemljaIstovara: null,
      postanskiBrojIstovara: "",
      gradIstovara: "",
      adresaIstovara: "",
      vrstaRobeIstovara: "",
      brojPaletaIstovara: null,
      tezinaRobeIstovara: null,
      referentniBrojIstovara: "",
    },
  ]);

  const [formDataShipment, setFormDataShipment] = useState({
    radniNalog: "",
    brojFakture: "",
    klijent: null,
    izvoznoCarinjenje: "",
    nazivSpediteraIzvoz: "",
    granicaObavezna: false,
    granicniPrelaz: null,
    nazivSpediteraGranica: "",
    napomenaGranica: "",
    uvoznoCarinjenje: "",
    nazivSpediteraUvoz: "",
    napomenaZaVozaca: "",
    obracunKursa: null,
    cena: null,
    valuta: null,
    kurs: null,
    rokPlacanja: null,
    napomenaPlacanje: "",
    dodatniTroskovi: "",
    troskoviPregleda: "",
    tipNaloga: null,
    referentniBroj: "",
    finansijskiStatus: null,
    statusSefa: null,
    uploadedFileWorkLog: "",
    statusRadnogNaloga: null,
    objavljenoVozacu: false,
    datumObjave: null,
  });

  const [formDataShipmentFILES, setFormDataShipmentFILES] = useState({
    uploadedFileWorkLog: [],
  });

  const handleUploadAndSaveFiles = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("entityType", "radniNalog");

    // Object.entries(formDataShipmentFILES).forEach(([key, file]) => {
    // if (file) formData.append(key, file);
    // });

    Object.entries(formDataShipmentFILES).forEach(([key, files]) => {
      if (files && files.length > 0) {
        files.forEach((file) => formData.append(key, file));
      }
    });

    let requestOptionsFiles = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + auth.token,
      },
      body: formData,
    };

    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/trip/InsertWorkLogFiles",
      requestOptionsFiles
    )
      .then(handleErrors)
      .then((data) => {
        setIzabranRadni(false);
        setPopuni(false);
        resetData();
        resetDataFiles();

        toast.current.show({
          severity: "success",
          summary: data.message,
          life: 3000,
        });
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage[0].message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  };

  useEffect(() => {
    if (trip) {
      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          putniNalog: trip,
        }),
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/trip/WorkLog", requestOptions)
        .then(handleErrors)
        .then((data) => {
          const stringifiedJson = data[0][""];
          const parsedData = JSON.parse(stringifiedJson);

          setRadniNaloziDB(parsedData.RadniNaloziDB);
          setKlijentiOptions(parsedData.KlijentiOptions);
          setZemljeOptions(parsedData.ZemljeOptions);
          setGranicniPrelaziOptions(parsedData.GranicniPrelaziOptions);
          setObracunKursaOptions(parsedData.ObracunKursaOptions);
          setValuteOptions(parsedData.ValuteOptions);
          setTipNalogaOptions(parsedData.TipNalogaOptions);
          setStatusNalogaOptions(parsedData.StatusNalogaOptions);
          setFinansijskiStatusOptions(parsedData.FinansijskiStatusOptions);
          setStatusSefaOptions(parsedData.StatusSefaOptions);
          setValuteEffectivaOptions(parsedData.ValuteEffectivaOptions);
          setKurseviDB(parsedData.Kursevi);
          setKurseviEffectivaDB(parsedData.KurseviEffectiva);
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      if (idWorkLog) {
        setIdWorkLog(null);
      }
      if (izabranRadni) {
        setIzabranRadni(false);
      }
      if (popuni) {
        setPopuni(false);
      }
    }
  }, [formSubmitted, trip]);

  const handleChange = (e, index) => {
    const { name, value } = e.target || e; // ako Dropdown šalje samo value

    if (name === "ostaliVozaci") {
      setFormDataShipment((prev) => {
        const updated = [...prev.ostaliVozaci];
        updated[index] = value; // menjamo samo tog vozača
        return { ...prev, ostaliVozaci: updated };
      });
    }

    if (name in formDataShipment) {
      if (name === "klijent") {
        let val = klijentiOptions.filter((x) => x.value == value);
        if (val[0].valuta)
          setFormDataShipment((prev) => ({
            ...prev,
            rokPlacanja: val[0].valuta,
          }));
        else setFormDataShipment((prev) => ({ ...prev, rokPlacanja: null }));
      }

      if (name === "obracunKursa" && value === 182)
        setFormDataShipment((prev) => ({ ...prev, kurs: null }));

      if (name === "obracunKursa" && formDataShipment.kurs != null)
        setFormDataShipment((prev) => ({ ...prev, kurs: null }));

      if (name === "valuta" && formDataShipment.kurs != null)
        setFormDataShipment((prev) => ({ ...prev, kurs: null }));

      if (name == "obracunKursa" && formDataShipment.valuta != null) {
        setFormDataShipment((prev) => ({ ...prev, valuta: null }));
      }

      setFormDataShipment((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Ako za traženi datum ne postoji kurs (npr. vikend kada NBS ne objavljuje kurs),
  // vraća se kurs sa prvog prethodnog dana za koji postoji zapis.
  const findKursWithFallback = (kurseviList, valutaId, baseDate) => {
    let d = new Date(baseDate.getTime() + 2 * 60 * 60 * 1000);
    for (let i = 0; i < 30; i++) {
      const day = d.toISOString().slice(0, 10);
      const found = kurseviList.find(
        (x) =>
          x.id === valutaId &&
          typeof x.DateEntered === "string" &&
          x.DateEntered.slice(0, 10) === day
      );
      if (found) return found;
      d = new Date(d.getTime() - 24 * 60 * 60 * 1000);
    }
    return null;
  };

  const handleChangeCourse = () => {
    let kurs;

    if (formDataShipment.valuta == 220) {
      // RSD je domaća valuta - NBS ne vodi kurs RSD prema RSD, kurs je 1
      setFormDataShipment((prev) => ({ ...prev, kurs: 1 }));
      return;
    }

    if (formDataShipment.obracunKursa != null) {
      if (formDataShipment.obracunKursa == 185) {
        if (!kurseviEffectivaDB) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Nije povučen kurs Efektive za današnji dan!",
            life: 3000,
          });
          return;
        }
        kurs = kurseviEffectivaDB.find(
          (currency) => currency.id === formDataShipment.valuta
        );

        if (!kurs) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Za izabranu valutu ne postoji kurs Efektive za današnji dan, unesite ručno!",
            life: 3000,
          });
          return;
        }

        setFormDataShipment((prev) => ({ ...prev, kurs: kurs.srednji }));
      } else if (formDataShipment.obracunKursa == 183) {
        if (!kurseviDB) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Nije povučen kurs za današnji dan!",
            life: 3000,
          });
          return;
        }
        const todayStr = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"

        kurs = kurseviDB.find(
          (x) =>
            x.id === formDataShipment.valuta &&
            typeof x.DateEntered === "string" &&
            x.DateEntered.slice(0, 10) === todayStr
        );

        if (!kurs) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Za izabranu valutu ne postoji srednji kurs za današnji dan, unesite ručno!",
            life: 3000,
          });
          return;
        }

        setFormDataShipment((prev) => ({ ...prev, kurs: kurs.srednji }));
      } else if (formDataShipment.obracunKursa == 179) {
        if (!kurseviDB) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Nije povučen kurs za današnji dan!",
            life: 3000,
          });
          return;
        }
        const base = new Date(
          formDataShipmentExport[formDataShipmentExport.length - 1].datumUtovara
        );

        kurs = findKursWithFallback(kurseviDB, formDataShipment.valuta, base);

        if (!kurs) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Za izabranu valutu ne postoji srednji kurs na dan utovara, unesite ručno!",
            life: 3000,
          });
          return;
        }

        setFormDataShipment((prev) => ({ ...prev, kurs: kurs.srednji }));
      } else if (formDataShipment.obracunKursa == 180) {
        if (!kurseviDB) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Nije povučen kurs za današnji dan!",
            life: 3000,
          });
          return;
        }

        const base = new Date(
          formDataShipmentImport[
            formDataShipmentImport.length - 1
          ].datumIstovara
        );

        kurs = findKursWithFallback(kurseviDB, formDataShipment.valuta, base);

        if (!kurs) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Za izabranu valutu ne postoji srednji kurs na dan istovara, unesite ručno!",
            life: 3000,
          });
          return;
        }

        setFormDataShipment((prev) => ({ ...prev, kurs: kurs.srednji }));
      }
    }
  };

  const handleChangeDocUpload = (name, files) => {
    if (name === "uploadedFileWorkLog") {
      if (files) {
        // Ako je files niz, dodajemo sve fajlove, ako je jedan fajl, pravimo niz od njega
        const filesArray = Array.isArray(files) ? files : [files];
        setFormDataShipmentFILES((prev) => ({
          ...prev,
          [name]: [...prev[name], ...filesArray],
        }));
      } else {
        // Ako je files null, resetujemo vrednost
        setFormDataShipmentFILES((prev) => ({ ...prev, [name]: [] }));
      }
    } else {
      setFormDataShipmentFILES((prev) => ({ ...prev, [name]: files }));
    }
  };

  const popuniStavke = (apiData) => {
    const data = apiData[0]; // Pretpostavka: API vraća niz sa jednim objektom

    setFormDataShipment({
      radniNalog: data.radniNalog || "",
      brojFakture: data.brojFakture || "",
      klijent: data.klijent || null,
      // Izvozno carinjenje
      izvoznoCarinjenje: data.izvoznoCarinjenje || "",
      nazivSpediteraIzvoz: data.nazivSpediteraIzvoz || "",
      // Granični prelaz
      granicaObavezna: !!(data.granicniPrelaz || data.nazivSpediteraGranica),
      granicniPrelaz: data.granicniPrelaz || null,
      nazivSpediteraGranica: data.nazivSpediteraGranica || "",
      napomenaGranica: data.napomenaGranica || "",
      // Uvozno carinjenje
      uvoznoCarinjenje: data.uvoznoCarinjenje || "",
      nazivSpediteraUvoz: data.nazivSpediteraUvoz || "",
      // Napomena
      napomenaZaVozaca: data.napomenaZaVozaca || "",
      obracunKursa: data.obracunKursa || null,
      cena: data.cena || null,
      valuta: data.valuta || null,
      kurs: data.kurs || null,
      rokPlacanja: data.rokPlacanja || null,
      napomenaPlacanje: data.napomenaPlacanje || "",
      dodatniTroskovi: data.dodatniTroskovi || "",
      troskoviPregleda: data.troskoviPregleda || "",
      tipNaloga: data.tipNaloga || null,
      referentniBroj: data.referentniBroj || "",
      finansijskiStatus: data.finansijskiStatus || null,
      statusSefa: data.statusSefa || null,
      uploadedFileWorkLog: data.uploadedFileWorkLog || "",
      statusRadnogNaloga: data.statusRadnogNaloga || null,
      objavljenoVozacu: !!data.objavljenoVozacu,
      datumObjave: data.datumObjave || null,
    });
    if (data.Utovari) {
      const exportData = data.Utovari.map((utovar) => ({
        ID: utovar.ID || null,
        datumUtovara: utovar.datumUtovara
          ? new Date(utovar.datumUtovara)
          : null,
        nazivPreduzecaUtovara: utovar.nazivPreduzecaUtovara || "",
        zemljaUtovara: utovar.zemljaUtovara || null,
        postanskiBrojUtovara: utovar.postanskiBrojUtovara || "",
        gradUtovara: utovar.gradUtovara || "",
        adresaUtovara: utovar.adresaUtovara || "",
        ADRRobaUtovara: utovar.ADRRobaUtovara || null,
        vrstaRobeUtovara: utovar.vrstaRobeUtovara || "",
        referentniBrojUtovara: utovar.referentniBrojUtovara || "",
        brojPaletaUtovara: utovar.brojPaletaUtovara || null,
        tezinaRobeUtovara: utovar.tezinaRobeUtovara || null,
        temperaturniRezimUtovara: utovar.temperaturniRezimUtovara || "",
        napomenaIzvoz: utovar.napomenaIzvoz || "",
        vrednostRobe: utovar.vrednostRobe || null,
        vrednostRobeValuta: utovar.vrednostRobeValuta || null,
      }));

      // Set the state with the transformed data
      setFormDataShipmentExport(exportData);
    }
    if (data.Istovari) {
      const importData = data.Istovari.map((istovar) => ({
        ID: istovar.ID || null,
        nazivPreduzecaIstovara: istovar.nazivPreduzecaIstovara || "",
        datumIstovara: istovar.datumIstovara
          ? new Date(istovar.datumIstovara)
          : null,
        zemljaIstovara: istovar.zemljaIstovara || null,
        postanskiBrojIstovara: istovar.postanskiBrojIstovara || "",
        gradIstovara: istovar.gradIstovara || "",
        adresaIstovara: istovar.adresaIstovara || "",
        napomenaUvoz: istovar.napomenaUvoz || "",

        // Dodatni podaci o istovaru
        vrstaRobeIstovara: istovar.vrstaRobeIstovara || "",
        brojPaletaIstovara: istovar.brojPaletaIstovara || null,
        tezinaRobeIstovara: istovar.tezinaRobeIstovara || null,
        referentniBrojIstovara: istovar.referentniBrojIstovara || "",
      }));

      // Set the state with the transformed data
      setFormDataShipmentImport(importData);
    }
  };

  const popuniRedove = async (id = idWorkLog) => {
    setPopuni(true);
    if (!id) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Niste izabrali radni nalog da bi popunili podatke!",
        life: 3000,
      });
    } else {
      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: id
        }),
      };

      await fetch(
        process.env.REACT_APP_BACKEND_URL + "/trip/FillInTripWorkData",
        requestOptions
      )
        .then(handleErrors)
        .then((data) => {
          if (data.message) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: data.message,
              life: 3000,
            });
            return;
          }

          popuniStavke(data);

          toast.current.show({
            severity: "success",
            summary: "Uspešno popunjavanje podataka radnog naloga!",
            life: 3000,
          });

          //ubaciti deo da se forma ID za dalji unos
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    }
  };

  const resetData = () => {
    setFormDataShipment({
      radniNalog: "",
      brojFakture: "",
      klijent: null,
      // Izvozno carinjenje
      izvoznoCarinjenje: "",
      nazivSpediteraIzvoz: "",

      // Granični prelaz
      granicaObavezna: false,
      granicniPrelaz: null,
      nazivSpediteraGranica: "",
      napomenaGranica: "",

      // Uvozno carinjenje
      uvoznoCarinjenje: "",
      nazivSpediteraUvoz: "",
      //Napomena
      napomenaZaVozaca: "",
      obracunKursa: null,
      cena: null,
      valuta: null,
      kurs: null,
      rokPlacanja: null,
      napomenaPlacanje: "",
      dodatniTroskovi: "",
      troskoviPregleda: "",
      tipNaloga: null,
      referentniBroj: "",
      finansijskiStatus: null,
      statusSefa: null,
      uploadedFileWorkLog: "",
      statusRadnogNaloga: null,
      objavljenoVozacu: false,
      datumObjave: null,
    });

    setFormDataShipmentExport([
      {
        datumUtovara: null,
        nazivPreduzecaUtovara: "",
        zemljaUtovara: null,
        postanskiBrojUtovara: "",
        gradUtovara: "",
        adresaUtovara: "",
        ADRRobaUtovara: null,
        vrstaRobeUtovara: "",
        referentniBrojUtovara: "",
        brojPaletaUtovara: null,
        tezinaRobeUtovara: null,
        temperaturniRezimUtovara: "",
        napomenaIzvoz: "",
        vrednostRobe: null,
        vrednostRobeValuta: null,
      },
    ]);

    setFormDataShipmentImport([
      {
        nazivPreduzecaIstovara: "",
        napomenaUvoz: "",
        datumIstovara: null,
        zemljaIstovara: null,
        postanskiBrojIstovara: "",
        gradIstovara: "",
        adresaIstovara: "",
        // Dodatni podaci o istovaru
        vrstaRobeIstovara: "",
        brojPaletaIstovara: null,
        tezinaRobeIstovara: null,
        referentniBrojIstovara: "",
      },
    ]);
  };
  const resetDataFiles = () => {
    setFormDataShipmentFILES((prev) => ({
      ...prev,
      uploadedFileWorkLog: [],
    }));
  };
  const handlePrintFuncWork = (id) => {
    confirmDialog({
      message: "Unos putnog naloga je završen. Štampa?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptPrint(id),
      reject: rejectPrint,
    });
    //FILES
  };
  const acceptPrint = async (id) => {
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_work: id
      }),
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/trip/printServiceWorkLog",
      requestOptions
    )
      .then(handleErrors)
      .then((data) => {
        if (data) {
          handlePrintWork(data);
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  };
  const rejectPrint = () => {
    console.log("Odbijeno štampanje podataka!");
  };

  const handleFormSubmit = (e) => {
    e.preventDefault(); // bitno da ne submituje bez validacije
    setFormSubmitted(true);
    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity(); // prikazuje native browser poruke
      return;
    }
    handleUploadAndSave();
  };
  const handleFormSubmitInovice = (e) => {




    e.preventDefault(); // bitno da ne submituje bez validacije
    setFormSubmittedInvoice(true);
    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity(); // prikazuje native browser poruke
      return;
    }

    if(formDataShipment.obracunKursa == null || formDataShipment.cena == '' || formDataShipment.cena == null ||
      formDataShipment.valuta == null || (formDataShipment.obracunKursa != 181 && (formDataShipment.kurs == '' || formDataShipment.kurs == null)) || 
      formDataShipment.rokPlacanja == '' || formDataShipment.rokPlacanja == null || formDataShipment.statusRadnogNaloga == null
    ) return;

    fakturisanjeTure();
  };
  const handleUploadAndSave = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite nastaviti sa unosom?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptInsert,
      reject: rejectInsert,
    });
    //FILES
  };

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + "Z";
  }

  const acceptInsert = async () => {
    //Provera da li je su sva required polja uneta
    // Utovar u Srbiji (zemlja == 1) a istovar u inostranstvu, ili obrnuto → granica je obavezna
    const utovarUSrbiji = formDataShipmentExport.some((e) => e.zemljaUtovara == 1);
    const utovarUInostranstvu = formDataShipmentExport.some((e) => e.zemljaUtovara && e.zemljaUtovara != 1);
    const istovarUSrbiji = formDataShipmentImport.some((i) => i.zemljaIstovara == 1);
    const istovarUInostranstvu = formDataShipmentImport.some((i) => i.zemljaIstovara && i.zemljaIstovara != 1);
    const prelazakGranice =
      (utovarUSrbiji && istovarUInostranstvu) ||
      (utovarUInostranstvu && istovarUSrbiji);

    const granicaObavezna = formDataShipment.granicaObavezna || prelazakGranice;
    if (prelazakGranice && !formDataShipment.granicaObavezna)
      setFormDataShipment((prev) => ({ ...prev, granicaObavezna: true }));
    else
      setFormDataShipment((prev) => ({ ...prev, granicaObavezna: false }));

    if (changeView != 1 && formDataShipment.klijent == null) {
      setChangeView(1);
      return;
    }
    if (
      changeView != 2 &&
      formDataShipmentExport.some(
        (item) =>
          item.datumUtovara == null ||
          item.nazivPreduzecaUtovara === "" ||
          item.zemljaUtovara == null ||
          item.postanskiBrojUtovara === "" ||
          item.gradUtovara === "" ||
          item.adresaUtovara === ""
      )
    ) {
      setChangeView(2);
      return;
    }
    if (
      changeView != 3 &&
      granicaObavezna &&
      (formDataShipment.granicniPrelaz == null ||
        formDataShipment.nazivSpediteraGranica == "")
    ) {
      setChangeView(3);
      return;
    }
    if (
      changeView != 4 &&
      formDataShipmentImport.some(
        (item) =>
          item.datumIstovara == null ||
          item.nazivPreduzecaIstovara === "" ||
          item.zemljaIstovara == null ||
          item.postanskiBrojIstovara === "" ||
          item.gradIstovara === "" ||
          item.adresaIstovara === ""
      )
    ) {
      setChangeView(4);
      return;
    }
    if (changeView != 5 && formDataShipment.tipNaloga == null) {
      setChangeView(5);
      return;
    }

    //DATA
    const hasAnyValueTripWorkLog = Object.values(formDataShipment).some(
      (value) => {
        if (value === null || value === "") return false;

        // Check if it's a valid Date object
        if (value instanceof Date && isNaN(value.getTime())) return false;

        return true;
      }
    );
    //FILES
    const hasAnyValueShipmentFiles = Object.values(formDataShipmentFILES).some(
      (value) => {
        // Provera za null ili prazan string
        if (value === null || value === "") return false;

        // Provera za nevalidan Date
        if (value instanceof Date && isNaN(value.getTime())) return false;

        // Specijalna provera za nizove
        if (Array.isArray(value)) {
          // Vraća true ako niz nije prazan i sadrži bar jedan validan fajl/objekat
          return (
            value.length > 0 &&
            value.some((item) => item !== null && item !== "")
          );
        }

        // Provera za obične fajlove/objekte
        return true;
      }
    );

    if (izabranRadni && trip) {
      if (hasAnyValueTripWorkLog) {
        const izvoznik = (
          Array.isArray(formDataShipmentExport) ? formDataShipmentExport : []
        ).map((ist) => ({
          ...ist,
          datumUtovara: ist.datumUtovara ? toUtcIso(ist.datumUtovara) : null,
        }));

        const uvoznik = (
          Array.isArray(formDataShipmentImport) ? formDataShipmentImport : []
        ).map((uv) => ({
          ...uv,
          datumIstovara: uv.datumIstovara ? toUtcIso(uv.datumIstovara) : null,
        }));

        let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idWorkLog,
            formDataShipment,
            izvoznik: izvoznik,
            uvoznik: uvoznik,
          }),
        };

        await fetch(
          process.env.REACT_APP_BACKEND_URL + "/trip/UpdateTripWork",
          requestOptions
        )
          .then(handleErrors)
          .then((data) => {
            if (data) {
              if (
                data[0].message &&
                data[0].message != "Nema izmena u podacima radnog naloga."
              ) {
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: data[0].message,
                  life: 3000,
                });
                return;
              }

              if (data[0].message == "Nema izmena u podacima radnog naloga.") {
                toast.current.show({
                  severity: "warn",
                  summary: data[0].message,
                  life: 3000,
                });
              } else {
                toast.current.show({
                  severity: "success",
                  summary: "Uspešna izmena podataka radnog naloga!",
                  life: 3000,
                });
              }
              setFormSubmitted(false);
              setIzabranRadni(false);
              setPopuni(false);
              if ((idWorkLog || data.ID) && hasAnyValueShipmentFiles) {
                handleUploadAndSaveFiles(idWorkLog || data.ID);
              }
              if (data[0].ID) {
                handlePrintFuncWork(data[0].ID);
              }
              resetData();
            }
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Upozorenje!",
          detail: "Niste popunili podatke radnog naloga za unos!",
          life: 3000,
        });
      }
    } else {
      if (trip) {
        if (hasAnyValueTripWorkLog) {
          const izvoznik = (
            Array.isArray(formDataShipmentExport) ? formDataShipmentExport : []
          ).map((ist) => ({
            ...ist,
            datumUtovara: ist.datumUtovara ? toUtcIso(ist.datumUtovara) : null,
          }));

          const uvoznik = (
            Array.isArray(formDataShipmentImport) ? formDataShipmentImport : []
          ).map((uv) => ({
            ...uv,
            datumIstovara: uv.datumIstovara ? toUtcIso(uv.datumIstovara) : null,
          }));

          const payload = {
                        ...formDataShipment,
                        finansijskiStatus: formDataShipment.finansijskiStatus != null ? formDataShipment.finansijskiStatus : 216,
                        statusSefa: formDataShipment.statusSefa != null ? formDataShipment.statusSefa : 218
                        };

          let requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + auth.token,
            },
            body: JSON.stringify({
              id: trip,
              formDataShipment:payload,
              izvoznik: izvoznik,
              uvoznik: uvoznik,
            }),
          };

          await fetch(
            process.env.REACT_APP_BACKEND_URL + "/trip/InsertTripWork",
            requestOptions
          )
            .then(handleErrors)
            .then((data) => {
              if (data.message) {
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: data.message,
                  life: 3000,
                });
                return;
              }
              setFormSubmitted(false);

              if (data.id && hasAnyValueShipmentFiles) {
                handleUploadAndSaveFiles(data.id);
              }
              if (data.ID) {
                handlePrintFuncWork(data.ID);
              }
              resetData();
              setIzabranRadni(false);

              toast.current.show({
                severity: "success",
                summary: "Uspešan unos podataka radnog naloga!",
                life: 3000,
              });

              //ubaciti deo da se forma ID za dalji unos
            })
            .catch((error) => {
              error.json().then((errorMessage) => {
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: errorMessage.message,
                  life: 3000,
                });
                console.log(errorMessage);
              });
            });
        } else {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Niste popunili podatke radnog naloga za unos!",
            life: 3000,
          });
        }
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Upozorenje!",
          detail:
            "Niste izabrali putni nalog. Izaberite putni nalog pa nastavite sa unosom!",
          life: 3000,
        });
      }
    }
  };
  const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };

  const fakturisanjeTure = () => {
    if (!idWorkLog) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail:
          "Niste izabrali radni nalog. Izaberite radni nalog da bi nastavili sa fakturisanjem!",
        life: 3000,
      });
    } else {
      confirmDialog({
        message:
          "Jel ste sigurni da želite nastaviti sa fakturisanjem radnog naloga?",
        acceptLabel: "Da",
        rejectLabel: "Ne",
        icon: "pi pi-info-circle",
        acceptClassName: "p-button-danger",
        accept: acceptInvoice,
        reject: rejectInvoice,
      });
    }
  };

  const acceptInvoice = async () => {
    if (!idWorkLog) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail:
          "Niste izabrali radni nalog. Izaberite radni nalog da bi nastavili sa fakturisanjem!",
        life: 3000,
      });
    } else {
      if (can('FAKTURE', 'edit')) {

         let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idWorkLog,
            obracunKursa: formDataShipment.obracunKursa,
            cena: formDataShipment.cena,
            valuta: formDataShipment.valuta,
            kurs: formDataShipment.kurs,
            rokPlacanja: formDataShipment.rokPlacanja,
            statusRadnogNaloga: formDataShipment.statusRadnogNaloga,
            /* Klik na Fakturiši je za korisnika snimanje CELOG bloka „Fakture",
               a ne samo finansijskih polja — ostala su se gubila jer se nisu ni
               slala. Kod referentnog broja se to videlo i dalje niz tok: izlazna
               faktura ga čita IZ BAZE u polje „Ref No", pa je ostajalo prazno
               iako je vrednost stajala u formi.

               Nisu tu samo `brojFakture` (dodeljuje ga sistem po fakturisanju) i
               `uploadedFileWorkLog` (fajl ide svojim putem, kroz upload). */
            dodatniTroskovi: formDataShipment.dodatniTroskovi,
            troskoviPregleda: formDataShipment.troskoviPregleda,
            referentniBroj: formDataShipment.referentniBroj,
            tipNaloga: formDataShipment.tipNaloga,
            statusSefa: formDataShipment.statusSefa,
            finansijskiStatus: formDataShipment.finansijskiStatus,
            napomenaPlacanje: formDataShipment.napomenaPlacanje
          }),
        };

        await fetch(
          process.env.REACT_APP_BACKEND_URL + "/trip/UpdateTripWorkFinance",
          requestOptions
        )
          .then(handleErrors)
          .then((data) => {
 
            if (data && data[0]?.message) {

                toast.current.show({
                  severity: "warn",
                  summary: "Upozorenje!",
                  detail: data[0].message,
                  life: 3000,
                });

             } else {
                setFormSubmittedInvoice(false);
                history.push({
                  pathname: "/fakture/izlazne_fakture/",
                  state: { idWorkLog },
                });
             }

          })
          .catch(async (error) => {
            /* Ranije je ovde stajalo samo error.json(). To radi kad je server
               odgovorio (handleErrors baca Response), ali NE i kad je greska
               mrezna ili JS: tada error.json nije funkcija, sam catch pukne i
               korisnik ne vidi nista — klik na "Da" izgleda kao da nista nije
               uradio. Zato se sada svaki oblik greske pretvori u poruku. */
            let poruka = "Fakturisanje nije uspelo.";

            if (error && typeof error.json === "function") {
              const telo = await error.json().catch(() => null);
              poruka = telo?.message || `${error.status} ${error.statusText || ""}`.trim();
            } else if (error?.message) {
              poruka = error.message;
            }

            toast.current.show({
              severity: "error",
              summary: "Greška",
              detail: poruka,
              life: 5000,
            });
            console.log("Fakturisanje radnog naloga nije uspelo:", error);
          })
          
      
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Upozorenje!",
          detail: "Nemate odgovarajuću ulogu profila za fakturisanje!",
          life: 3000,
        });
      }
    }
  };

  const rejectInvoice = () => {
    console.log("Odbijen fakturisanje radnog naloga!");
  };

  const selectIdWorkLogFUNC = (e) => {
    if (e.target.value == undefined) {
      setIzabranRadni(false);
      resetData();
      resetDataFiles();
    } else {
      setIzabranRadni(true);
      popuniRedove(e.target.value);
    }
    setIdWorkLog(e.target.value);
    setPopuni(false);
  };

  const handleDeleteWorkLog = () => {
    if (idWorkLog) {
      const izabraniRadniNalogLabel =
        radniNaloziDB.find((r) => r.value === idWorkLog)?.label || `${trip}/${idWorkLog}`;
      confirmDialog({
        message: `Jel ste sigurni da želite pasivizirati radni nalog: ${izabraniRadniNalogLabel}?`,
        acceptLabel: "Da",
        rejectLabel: "Ne",
        icon: "pi pi-info-circle",
        acceptClassName: "p-button-danger",
        accept: acceptDelete,
        reject: rejectDelete,
      });
    }
  };
  const acceptDelete = async () => {
    setFormSubmitted(true);
    if (izabranRadni) {
      let requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: idWorkLog
        }),
      };

      await fetch(
        process.env.REACT_APP_BACKEND_URL + "/trip/DeleteWorkLog",
        requestOptions
      )
        .then(handleErrors)
        .then((data) => {
          setIdWorkLog(null);
          setIzabranRadni(null);
          setPopuni(null);

          resetData();
          resetDataFiles();
          setFormSubmitted(false);
          toast.current.show({
            severity: "success",
            summary: "Uspešno pasiviziranje podataka radnog naloga!",
            life: 3000,
          });
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Nije moguće obrisati radni nalog, nije izabran!",
        life: 3000,
      });
    }
  };

  const rejectDelete = () => {
    console.log("Odbijeno brisanje radnog naloga!");
  };

  const handleObjaviVozacu = (objavi) => {
    if (!idWorkLog) return;
    confirmDialog({
      message: objavi
        ? t('ture.potvrdaObjaveVozacu')
        : t('ture.potvrdaPovlacenjaObjave'),
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: objavi ? "p-button-success" : "p-button-danger",
      accept: () => acceptObjaviVozacu(objavi),
    });
  };

  const acceptObjaviVozacu = async (objavi) => {
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id: idWorkLog, objavi: objavi ? 1 : 0 }),
    };

    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/trip/objaviRadniNalogVozacu",
      requestOptions
    )
      .then(handleErrors)
      .then((data) => {
        setFormDataShipment((prev) => ({
          ...prev,
          objavljenoVozacu: objavi,
          datumObjave: objavi ? new Date().toISOString() : null,
        }));
        toast.current.show({
          severity: "success",
          summary: data?.message || "Uspešno!",
          life: 3000,
        });
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  };

  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

    const invalidControlInvoice = (data) => {
    if (!formSubmittedInvoice) return false; // ← NE prikazuj grešku dok forma nije poslata

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const handleClickWorkLog = () => {
    if (idWorkLog) {
      // resetuj samo ako ima vrednost
      setIdWorkLog(null);
      setIzabranRadni(false);
      setPopuni(false);
      resetData();
    }
  };

  // Live status vozača/rute u tabu VOZAČ — isti RadniNalogVozacInit koji RutaVozaca
  // već koristi, samo pozvan i ovde da se status vidi ODMAH ispod napomene (ne samo
  // unutar dijaloga mape). Poluje na 10s dok je tab VOZAČ aktivan, da se status
  // ažurira sam kad vozač promeni stanje sa telefona, bez ručnog osvežavanja forme.
  useEffect(() => {
    if (changeView !== 6 || !idWorkLog) {
      setStatusVozacaInfo(null);
      return;
    }
    let otkazano = false;
    const ucitajStatus = () => {
      fetch(process.env.REACT_APP_BACKEND_URL + "/trip/RadniNalogVozacInit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
        body: JSON.stringify({ id_radni_nalog: idWorkLog }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (otkazano) return;
          const n = (data.NalogDB || [])[0] || null;
          setStatusVozacaInfo(n);
        })
        .catch(() => {});
    };
    ucitajStatus();
    const interval = setInterval(ucitajStatus, 10000);
    return () => { otkazano = true; clearInterval(interval); };
  }, [changeView, idWorkLog, auth.token]);

  return (
    <div className="p-fluid grid formUnosZap">
      <Toast ref={toast} />

      <div
        className="col-12"
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: "2%",
          width: "100%",
        }}
      >
        <Button
          id={changeView == 1 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.opste')}
          type="button"
          className="mt-3 putniNalogButtonsShift"
          onClick={() => {
            setChangeView(1);
          }}
        />
        <i
          className="pi pi-chevron-right"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 0.5% 0 0.5%",
            width: "fit-content",
          }}
        ></i>
        <Button
          id={changeView == 2 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.utovar')}
          type="button"
          className="mt-3 radniNalogShift"
          onClick={() => {
            setChangeView(2);
          }}
        />
        <i
          className="pi pi-chevron-right"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 0.5% 0 0.5%",
            width: "fit-content",
          }}
        ></i>
        <Button
          id={changeView == 3 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.carina')}
          type="button"
          className="mt-3 radniNalogShift"
          onClick={() => {
            setChangeView(3);
          }}
        />
        <i
          className="pi pi-chevron-right"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 0.5% 0 0.5%",
            width: "fit-content",
          }}
        ></i>
        <Button
          id={changeView == 4 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.istovar')}
          type="button"
          className="mt-3 radniNalogShift"
          onClick={() => {
            setChangeView(4);
          }}
        />
        <i
          className="pi pi-chevron-right"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 0.5% 0 0.5%",
            width: "fit-content",
          }}
        ></i>
        <Button
          id={changeView == 5 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.fakture')}
          type="button"
          className="mt-3 radniNalogShift"
          onClick={() => {
            setChangeView(5);
          }}
        />
        {/* VOZAČ i ŠABLON nisu deo lanca unosa (utovar → carina → istovar →
            fakture) nego samostalne radnje, pa ih crta odvaja umesto strelice */}
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 1% 0 1%",
            width: "fit-content",
            fontSize: "1.4rem",
            opacity: 0.45,
            userSelect: "none",
          }}
        >
          |
        </span>
        <Button
          id={changeView == 6 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.vozacTab')}
          icon="pi pi-user"
          type="button"
          className="mt-3 radniNalogShift radniNalogAkcija"
          onClick={() => {
            setChangeView(6);
          }}
        />
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 1% 0 1%",
            width: "fit-content",
            fontSize: "1.4rem",
            opacity: 0.45,
            userSelect: "none",
          }}
        >
          |
        </span>
        {/* DOKUMENTA — ono sto vozac slika sa telefona (CMR, termo ispis,
            ostecenje robe). Telefon ih je slao od pocetka, a u TMS-u se nisu
            videla nigde: web ruta je stajala napravljena i niko je nije zvao.
            Broj 8, ne 7 — 7 je rezervisan za odlozeni "Sablon" panel ispod. */}
        <Button
          id={changeView == 8 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.rnDokTab')}
          icon="pi pi-paperclip"
          type="button"
          className="mt-3 radniNalogShift radniNalogAkcija"
          onClick={() => {
            setChangeView(8);
          }}
        />
        {/* ŠABLON — odloženo, sadržaj nije rađen. Ostaje zakomentarisano da se
            vrati kad mu dođe red (uz njega ide i panel changeView == 7 dole).
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 1% 0 1%",
            width: "fit-content",
            fontSize: "1.4rem",
            opacity: 0.45,
            userSelect: "none",
          }}
        >
          |
        </span>
        <Button
          id={changeView == 7 && activeClass}
          style={{ width: "fit-content", height: "fit-content" }}
          label={t('ture.sablonTab')}
          icon="pi pi-copy"
          type="button"
          className="mt-3 radniNalogShift radniNalogAkcija"
          onClick={() => {
            setChangeView(7);
          }}
        />
        */}

        <div style={{ width: "60%", margin: "2%" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h4>{t('ture.izborRadnog')}:</h4>

            <CustomDropdown
              style={{ width: "30.65%", margin: "0 0 0 2%" }}
              options={radniNaloziDB || []}
              value={idWorkLog}
              placeholder={t('ture.brojRadnogNaloga')}
              optionLabel="label"
              onChange={selectIdWorkLogFUNC}
              onFocus={handleClickWorkLog}
            />

            {izabranRadni && (
              <Button
                label={t('common.delete')}
                className="mt-3 zaposleniShift"
                onClick={handleDeleteWorkLog}
                style={{ width: "fit-content" }}
              />
            )}
          </div>
        </div>
      </div>
      <form autoComplete="off" ref={formRef}>
        {changeView == 1 && (
          <Card className="gridRadniNalozi">
            <div className="gridLicni">
              {" "}
              <div className="col-12 md:col-6">
                <label htmlFor="radniNalog">{t('ture.brojRadnogNaloga')}:</label>
                <InputText
                  id="radniNalog"
                  name="radniNalog"
                  readOnly
                  style={{ backgroundColor: "#efefef" }}
                  value={formDataShipment.radniNalog}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="klijent">{t('nova.klijent')}:</label>
                <CustomDropdown
                  id="klijent"
                  name="klijent"
                  required
                  invalid={invalidControl(formDataShipment.klijent)}
                  value={formDataShipment.klijent}
                  options={klijentiOptions}
                  optionLabel="label"
                  onChange={handleChange}
                  placeholder={t('nova.phKlijenta')}
                />
              </div>
            </div>{" "}
          </Card>
        )}
        {changeView == 2 && (
          <Card className="gridRadniNalozi">
            <div className="gridDokumenti">
              <div
                className="red1 redDokument firstDivDoc"
                style={{ alignItems: "center", maxWidth: "100%" }}
              >
                <div
                  className="col-12"
                  style={{ width: "fitcontent", height: "100%" }}
                >
                  <h4
                    style={{
                      width: "fitcontent",
                      height: "100%",
                      padding: "1rem",
                    }}
                  >
                    Utovari:
                  </h4>
                </div>
                <div className="redMiddleUtovarIstovar">
                  {formDataShipmentExport.map((shipmentExport, index) => (
                    <Card>
                      <div key={index} className="red1 gridUtovarIstovar">
                        <div className="col-12 md:col-6">
                          <label htmlFor={`datumUtovara-${index}`}>
                            Datum utovara:
                          </label>
                          <Calendar
                            id={`datumUtovara-${index}`}
                            required
                            invalid={invalidControl(
                              shipmentExport.datumUtovara
                            )}
                            value={shipmentExport.datumUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "datumUtovara",
                                e.target.value
                              )
                            }
                            showIcon
                            mask="99.99.9999"
                            dateFormat="dd.mm.yy"
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`nazivPreduzecaUtovara-${index}`}>
                            Naziv preduzeća:
                          </label>
                          <InputText
                            id={`nazivPreduzecaUtovara-${index}`}
                            required
                            invalid={invalidControl(
                              shipmentExport.nazivPreduzecaUtovara
                            )}
                            value={shipmentExport.nazivPreduzecaUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "nazivPreduzecaUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`zemljaUtovara-${index}`}>
                            Zemlja:
                          </label>
                          <CustomDropdown
                            id={`zemljaUtovara-${index}`}
                            required
                            invalid={invalidControl(
                              shipmentExport.zemljaUtovara
                            )}
                            value={shipmentExport.zemljaUtovara}
                            options={zemljeOptions}
                            placeholder={t('ture.phZemlju')}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "zemljaUtovara",
                                e.target.value
                              )
                            }
                            optionLabel="label"
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`postanskiBrojUtovara-${index}`}>
                            Poštanski broj:
                          </label>
                          <InputText
                            id={`postanskiBrojUtovara-${index}`}
                            required
                            invalid={invalidControl(
                              shipmentExport.postanskiBrojUtovara
                            )}
                            value={shipmentExport.postanskiBrojUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "postanskiBrojUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`gradUtovara-${index}`}>{t('ture.grad')}:</label>
                          <InputText
                            id={`gradUtovara-${index}`}
                            required
                            invalid={invalidControl(shipmentExport.gradUtovara)}
                            value={shipmentExport.gradUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "gradUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12">
                          <label htmlFor={`adresaUtovara-${index}`}>
                            Adresa:
                          </label>
                          <InputText
                            id={`adresaUtovara-${index}`}
                            required
                            invalid={invalidControl(
                              shipmentExport.adresaUtovara
                            )}
                            value={shipmentExport.adresaUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "adresaUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`vrstaRobeUtovara-${index}`}>
                            ADR / Vrsta robe:
                          </label>
                          <div style={{ display: "flex" }}>
                            <Checkbox
                              style={{
                                height: "auto",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              id={`ADRRobaUtovara-${index}`}
                              // checked je true ako je ili checkbox true ili postoji vrednost u inputu
                              checked={
                                !!shipmentExport.ADRRobaUtovara
                              }
                              onChange={(e) =>
                                handleExportChange(
                                  index,
                                  "ADRRobaUtovara",
                                  e.checked
                                )
                              }
                            />

                            <InputText
                            style={{ width: "80%" }}
                            id={`vrstaRobeUtovara-${index}`}
                            value={shipmentExport.vrstaRobeUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "vrstaRobeUtovara",
                                e.target.value
                              )
                            }
                          />
                          </div>
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`referentniBrojUtovara-${index}`}>
                            {t('ture.brojUtovara')}:
                          </label>
                          <InputText
                            id={`referentniBrojUtovara-${index}`}
                            value={shipmentExport.referentniBrojUtovara}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "referentniBrojUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`brojPaletaUtovara-${index}`}>
                            Broj paleta:
                          </label>
                          <InputNumber
                            id={`brojPaletaUtovara-${index}`}
                            value={shipmentExport.brojPaletaUtovara}
                            onValueChange={(e) =>
                              handleExportChange(
                                index,
                                "brojPaletaUtovara",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`tezinaRobeUtovara-${index}`}>
                            Težina robe:
                          </label>
                          <InputNumber
                            id={`tezinaRobeUtovara-${index}`}
                            value={shipmentExport.tezinaRobeUtovara}
                            onValueChange={(e) =>
                              handleExportChange(
                                index,
                                "tezinaRobeUtovara",
                                e.target.value
                              )
                            }
                            suffix=" kg"
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`temperaturniRezimUtovara-${index}`}>
                            Temperaturni režim:
                          </label>
                          <div style={{ display: "flex" }}>
                            <Checkbox
                              style={{
                                height: "auto",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              id={`temperaturniRezimCheck-${index}`}
                              // checked je true ako je ili checkbox true ili postoji vrednost u inputu
                              checked={
                                shipmentExport.temperaturniRezimCheck ||
                                Boolean(shipmentExport.temperaturniRezimUtovara)
                              }
                              onChange={(e) =>
                                handleExportChange(
                                  index,
                                  "temperaturniRezimCheck",
                                  e.checked
                                )
                              }
                            />

                            <InputText
                              style={{ width: "80%" }}
                              id={`temperaturniRezimUtovara-${index}`}
                              // input je aktivan ako je checkbox čekiran ili već postoji vrednost
                              disabled={
                                !(
                                  shipmentExport.temperaturniRezimCheck ||
                                  Boolean(
                                    shipmentExport.temperaturniRezimUtovara
                                  )
                                )
                              }
                              required={shipmentExport.temperaturniRezimCheck}
                              invalid={
                                shipmentExport.temperaturniRezimCheck
                                  ? invalidControl(
                                      shipmentExport.temperaturniRezimUtovara
                                    )
                                  : null
                              }
                              value={
                                shipmentExport.temperaturniRezimUtovara || ""
                              }
                              onChange={(e) =>
                                handleExportChange(
                                  index,
                                  "temperaturniRezimUtovara",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`vrednostRobe-${index}`}>
                            Vrednost robe:
                          </label>
                          <InputNumber
                            id={`vrednostRobe-${index}`}
                            value={shipmentExport.vrednostRobe}
                            onValueChange={(e) =>
                              handleExportChange(
                                index,
                                "vrednostRobe",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label htmlFor={`vrednostRobeValuta-${index}`}>
                            Valuta:
                          </label>
                          <CustomDropdown
                            id={`vrednostRobeValuta-${index}`}
                            required={shipmentExport.vrednostRobe !== null}
                            invalid={
                              shipmentExport.vrednostRobe !== null
                                ? invalidControl(
                                    shipmentExport.vrednostRobeValuta
                                  )
                                : null
                            }
                            value={shipmentExport.vrednostRobeValuta}
                            options={valuteOptions}
                            placeholder={t('nova.phValutu')}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "vrednostRobeValuta",
                                e.target.value
                              )
                            }
                            optionLabel="label"
                          />
                        </div>
                        <div
                          className="col-12 md:col-6"
                          style={{ flex: "0 0 37.5%" }}
                        >
                          <label htmlFor={`napomenaIzvoz-${index}`}>
                            Napomena (utovar):
                          </label>
                          <InputTextarea
                            id={`napomenaIzvoz-${index}`}
                            value={shipmentExport.napomenaIzvoz}
                            onChange={(e) =>
                              handleExportChange(
                                index,
                                "napomenaIzvoz",
                                e.target.value
                              )
                            }
                            rows={3}
                          />
                        </div>

                        <div className="col-12 md:col-6 flex align-items-end minusButtonODG">
                          <Button
                            icon="pi pi-minus"
                            className="p-button-danger"
                            type="button"
                            onClick={() => removeExport(index)}
                            disabled={formDataShipmentExport.length === 1}
                          />
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
                <div className="col-12" style={{ marginTop: "0" }}>
                  <Button
                    icon="pi pi-plus"
                    type="button"
                    label={t('ture.dodajUtovar')}
                    onClick={addExport}
                    className="p-button-success"
                  />
                </div>
              </div>
            </div>
          </Card>
        )}
        {changeView == 3 && (
          <Card className="gridRadniNalozi">
            <div className="gridCarinjenje">
              <div
                className="red1 redDokument"
                style={{ alignItems: "center", maxWidth: "100%" }}
              >
                <div className="col-12">
                  <h4 style={{ width: "fitcontent" }}>{t('ture.izvoznoCarinjenje')}:</h4>
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="izvoznoCarinjenje">{t('ture.izvoznoCarinjenje')}:</label>
                  <InputText
                    id="izvoznoCarinjenje"
                    name="izvoznoCarinjenje"
                    value={formDataShipment.izvoznoCarinjenje}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="nazivSpediteraIzvoz">
                    Naziv speditera (izvoz):
                  </label>
                  <InputText
                    id="nazivSpediteraIzvoz"
                    name="nazivSpediteraIzvoz"
                    value={formDataShipment.nazivSpediteraIzvoz}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div
                className="red2 redDokument"
                style={{ alignItems: "center" }}
              >
                <div className="col-12">
                  <h4>{t('ture.granica')}:</h4>
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="granicniPrelaz">
                    Granica / Granični prelaz:
                  </label>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    <Checkbox
                      style={{
                        flex: "0 0 20%",
                        width: "20%",
                        maxWidth: "20%",
                        height: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 0,
                      }}
                      id="granicaObavezna"
                      checked={!!formDataShipment.granicaObavezna}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "granicaObavezna",
                            value: e.checked,
                          },
                        })
                      }
                    />
                    <CustomDropdown
                      style={{ width: "80%", maxWidth: "80%", marginRight: 0 }}
                      id="granicniPrelaz"
                      name="granicniPrelaz"
                      required={formDataShipment.granicaObavezna}
                      invalid={
                        formDataShipment.granicaObavezna
                          ? invalidControl(formDataShipment.granicniPrelaz)
                          : false
                      }
                      value={formDataShipment.granicniPrelaz}
                      options={granicniPrelaziOptions}
                      placeholder={t('ture.phGranicniPrelaz')}
                      onChange={handleChange}
                      optionLabel="label"
                    />
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="nazivSpediteraGranica">
                    Naziv speditera (granica):
                  </label>
                  <InputText
                    id="nazivSpediteraGranica"
                    required={formDataShipment.granicaObavezna}
                    invalid={
                      formDataShipment.granicaObavezna
                        ? invalidControl(formDataShipment.nazivSpediteraGranica)
                        : false
                    }
                    name="nazivSpediteraGranica"
                    value={formDataShipment.nazivSpediteraGranica}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="napomenaGranica">{t('ture.napomenaGranica')}:</label>
                  <InputTextarea
                    id="napomenaGranica"
                    name="napomenaGranica"
                    value={formDataShipment.napomenaGranica}
                    onChange={handleChange}
                    rows={1}
                  />
                </div>
              </div>
              <div
                className="red1 redDokument"
                style={{ alignItems: "center", maxWidth: "100%" }}
              >
                <div className="col-12">
                  <h4 style={{ width: "fitcontent" }}>{t('ture.uvoznoCarinjenje')}:</h4>
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="uvoznoCarinjenje">{t('ture.uvoznoCarinjenje')}:</label>
                  <InputText
                    id="uvoznoCarinjenje"
                    name="uvoznoCarinjenje"
                    value={formDataShipment.uvoznoCarinjenje}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="nazivSpediteraUvoz">
                    Naziv speditera (uvoz):
                  </label>
                  <InputText
                    id="nazivSpediteraUvoz"
                    name="nazivSpediteraUvoz"
                    value={formDataShipment.nazivSpediteraUvoz}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </Card>
        )}
        {changeView == 4 && (
          <Card className="gridRadniNalozi">
            <div className="gridDokumenti">
              <div
                className="red1 redDokument firstDivDoc"
                style={{ alignItems: "center", maxWidth: "100%" }}
              >
                <div
                  className="col-12"
                  style={{ width: "fitcontent", height: "100%" }}
                >
                  <h4
                    style={{
                      width: "fitcontent",
                      height: "100%",
                      padding: "1rem",
                    }}
                  >
                    Istovari:
                  </h4>
                </div>
                <div className="redMiddleUtovarIstovar">
                  {formDataShipmentImport.map((shipmentImport, index) => (
                    <div key={index} className="red1 gridUtovarIstovar">
                      <div className="col-12 md:col-6">
                        <label htmlFor={`datumIstovara-${index}`}>
                          Datum istovara:
                        </label>
                        <Calendar
                          id={`datumIstovara-${index}`}
                          required
                          invalid={invalidControl(shipmentImport.datumIstovara)}
                          value={shipmentImport.datumIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "datumIstovara",
                              e.target.value
                            )
                          }
                          showIcon
                          mask="99.99.9999"
                          dateFormat="dd.mm.yy"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`nazivPreduzecaIstovara-${index}`}>
                          Naziv preduzeća:
                        </label>
                        <InputText
                          id={`nazivPreduzecaIstovara-${index}`}
                          required
                          invalid={invalidControl(
                            shipmentImport.nazivPreduzecaIstovara
                          )}
                          value={shipmentImport.nazivPreduzecaIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "nazivPreduzecaIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`zemljaIstovara-${index}`}>
                          Zemlja:
                        </label>
                        <CustomDropdown
                          id={`zemljaIstovara-${index}`}
                          required
                          invalid={invalidControl(
                            shipmentImport.zemljaIstovara
                          )}
                          value={shipmentImport.zemljaIstovara}
                          options={zemljeOptions}
                          placeholder={t('ture.phZemlju')}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "zemljaIstovara",
                              e.target.value
                            )
                          }
                          optionLabel="label"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`postanskiBrojIstovara-${index}`}>
                          Poštanski broj:
                        </label>
                        <InputText
                          id={`postanskiBrojIstovara-${index}`}
                          required
                          invalid={invalidControl(
                            shipmentImport.postanskiBrojIstovara
                          )}
                          value={shipmentImport.postanskiBrojIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "postanskiBrojIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`gradIstovara-${index}`}>{t('ture.grad')}:</label>
                        <InputText
                          id={`gradIstovara-${index}`}
                          required
                          invalid={invalidControl(shipmentImport.gradIstovara)}
                          value={shipmentImport.gradIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "gradIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12">
                        <label htmlFor={`adresaIstovara-${index}`}>
                          Adresa:
                        </label>
                        <InputText
                          id={`adresaIstovara-${index}`}
                          required
                          invalid={invalidControl(
                            shipmentImport.adresaIstovara
                          )}
                          value={shipmentImport.adresaIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "adresaIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`vrstaRobeIstovara-${index}`}>
                          Vrsta robe:
                        </label>
                        <InputText
                          id={`vrstaRobeIstovara-${index}`}
                          value={shipmentImport.vrstaRobeIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "vrstaRobeIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`brojPaletaIstovara-${index}`}>
                          Broj paleta:
                        </label>
                        <InputNumber
                          id={`brojPaletaIstovara-${index}`}
                          value={shipmentImport.brojPaletaIstovara}
                          onValueChange={(e) =>
                            handleImportChange(
                              index,
                              "brojPaletaIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`tezinaRobeIstovara-${index}`}>
                          Težina robe:
                        </label>
                        <InputNumber
                          id={`tezinaRobeIstovara-${index}`}
                          value={shipmentImport.tezinaRobeIstovara}
                          onValueChange={(e) =>
                            handleImportChange(
                              index,
                              "tezinaRobeIstovara",
                              e.target.value
                            )
                          }
                          suffix=" kg"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor={`referentniBrojIstovara-${index}`}>
                          {t('ture.brojIstovara')}:
                        </label>
                        <InputText
                          id={`referentniBrojIstovara-${index}`}
                          value={shipmentImport.referentniBrojIstovara}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "referentniBrojIstovara",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div
                        className="col-12 md:col-6"
                        style={{ flex: "0 0 37.5%" }}
                      >
                        <label htmlFor={`napomenaUvoz-${index}`}>
                          Napomena:
                        </label>
                        <InputTextarea
                          id={`napomenaUvoz-${index}`}
                          value={shipmentImport.napomenaUvoz}
                          onChange={(e) =>
                            handleImportChange(
                              index,
                              "napomenaUvoz",
                              e.target.value
                            )
                          }
                          rows={3}
                        />
                      </div>

                      <div className="col-12 md:col-6 flex align-items-end minusButtonODG">
                        <Button
                          icon="pi pi-minus"
                          className="p-button-danger"
                          type="button"
                          onClick={() => removeImport(index)}
                          disabled={formDataShipmentImport.length === 1}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-12" style={{ marginTop: "0" }}>
                  <Button
                    icon="pi pi-plus"
                    type="button"
                    label={t('ture.dodajIstovar')}
                    onClick={addImport}
                    className="p-button-success"
                  />
                </div>
              </div>
            </div>
          </Card>
        )}
        {changeView == 5 && (
          <Card className="gridRadniNalozi">
            <div className="gridLicni gridRadniNaloziFakture">
              <div className="col-12 md:col-6">
                <label htmlFor="obracunKursa">{t('ture.obracunKursa')}:</label>
                <Dropdown
                  id="obracunKursa"
                  name="obracunKursa"
                  invalid={invalidControlInvoice(formDataShipment.obracunKursa)}
                  value={formDataShipment.obracunKursa}
                  options={obracunKursaOptions}
                  onChange={handleChange}
                  placeholder={t('ture.phNacinObracuna')}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="cena">{t('ture.cena')}:</label>
                <InputNumber
                  id="cena"
                  name="cena"
                  invalid={invalidControlInvoice(formDataShipment.cena)}
                  value={formDataShipment.cena}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="valuta">{t('nova.valuta')}:</label>
                <CustomDropdown
                  id="valuta"
                  name="valuta"
                  required={formDataShipment.cena == null ? false : true}
                  invalid={
                    formDataShipment.cena != null || formDataShipment.cena != ''
                      ? invalidControlInvoice(formDataShipment.valuta)
                      : null
                  }
                  value={formDataShipment.valuta}
                  options={
                    formDataShipment.obracunKursa === 185
                      ? valuteEffectivaOptions
                      : valuteOptions
                  }
                  placeholder={t('nova.phValutu')}
                  onChange={handleChange}
                  onHide={handleChangeCourse}
                  optionLabel="label"
                />
              </div>
              <div className="col-12 md:col-6">
                {formDataShipment.obracunKursa == 181 && (
                  <p class="infoPoruka" style={{ fontSize: "10px" }}>
                    Kurs za izabrani datum se računa u delu fakture!
                  </p>
                )}
                <label htmlFor="kurs">{t('nova.kurs')}:</label>
                <InputNumber
                  id="kurs"
                  name="kurs"
                  disabled={formDataShipment.obracunKursa == 181}
                  required={formDataShipment.obracunKursa != 181 && formDataShipment.obracunKursa}
                  invalid={formDataShipment.obracunKursa != 181 ? invalidControlInvoice(formDataShipment.kurs) : null}
                  value={formDataShipment.kurs}
                  onValueChange={handleChange}
                  minFractionDigits={4}
                  maxFractionDigits={4}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="rokPlacanja">{t('ture.rokPlacanja')}:</label>
                <InputNumber
                  id="rokPlacanja"
                  name="rokPlacanja"
                  invalid={invalidControlInvoice(formDataShipment.rokPlacanja)}
                  value={formDataShipment.rokPlacanja}
                  onValueChange={handleChange}
                  step={15}
                  suffix=" dana"
                  min={0}
                  max={150}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="dodatniTroskovi">{t('ture.dodatniTroskovi')}:</label>
                <InputText
                  id="dodatniTroskovi"
                  name="dodatniTroskovi"
                  value={formDataShipment.dodatniTroskovi}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="troskoviPregleda">{t('ture.troskoviPregleda')}:</label>
                <InputText
                  id="troskoviPregleda"
                  name="troskoviPregleda"
                  value={formDataShipment.troskoviPregleda}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="referentniBroj">{t('ture.referentniBroj')}:</label>
                <InputText
                  id="referentniBroj"
                  name="referentniBroj"
                  value={formDataShipment.referentniBroj}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="brojFakture">{t('ture.brojFakture')}:</label>
                <InputText
                  id="brojFakture"
                  name="brojFakture"
                  readOnly
                  style={{ backgroundColor: "#efefef" }}
                  value={formDataShipment.brojFakture}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="statusSefa">{t('ture.fakturisanje')}:</label>
                <Button
                  label={formDataShipment.brojFakture ? "Fakturisano": "Fakturiši"}
                  className={formDataShipment.brojFakture ? "p-button-success": "p-button-danger"}
                  type="button"
                  onClick={handleFormSubmitInovice}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="tipNaloga">{t('ture.tipNaloga')}:</label>
                <Dropdown
                  id="tipNaloga"
                  name="tipNaloga"
                  required
                  invalid={invalidControl(formDataShipment.tipNaloga)}
                  value={formDataShipment.tipNaloga}
                  options={tipNalogaOptions}
                  onChange={handleChange}
                  placeholder={t('ture.phTipNaloga')}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="statusSefa">{t('nova.statusSefa')}:</label>
                <Dropdown
                  id="statusSefa"
                  name="statusSefa"
                  value={formDataShipment.statusSefa}
                  options={statusSefaOptions}
                  disabled 
                  onChange={handleChange}
                  placeholder={t('nova.phStatus')}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="finansijskiStatus">{t('nova.finansijskiStatus')}:</label>
                <Dropdown
                  id="finansijskiStatus"
                  name="finansijskiStatus"
                  value={formDataShipment.finansijskiStatus}
                  disabled 
                  options={finansijskiStatusOptions}
                  onChange={handleChange}
                  placeholder={t('nova.phStatus')}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="statusRadnogNaloga">{t('ture.statusRadnog')}:</label>
                <Dropdown
                  id="statusRadnogNaloga"
                  name="statusRadnogNaloga"
                  invalid={invalidControlInvoice(formDataShipment.statusRadnogNaloga)}
                  value={formDataShipment.statusRadnogNaloga}
                  options={statusNalogaOptions}
                  onChange={handleChange}
                  placeholder={t('nova.phStatus')}
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="docCPC">{t('ture.viseDokumenata')}:</label>
                {formDataShipmentFILES.uploadedFileWorkLog.length === 0 ? (
                  <FileUpload
                    name="uploadedFileWorkLog"
                    className={
                      formDataShipment.uploadedFileWorkLog !== ""
                        ? "green-btn"
                        : ""
                    }
                    customUpload={false}
                    multiple
                    auto={false}
                    chooseLabel="Izaberi"
                    uploadLabel="Pošalji"
                    mode="basic"
                    accept=".pdf,.jpg,.png"
                    maxFileSize={5000000}
                    onSelect={(e) =>
                      handleChangeDocUpload("uploadedFileWorkLog", e.files)
                    }
                  />
                ) : (
                  <div>
                    {formDataShipmentFILES.uploadedFileWorkLog.map(
                      (file, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "0.5rem",
                          }}
                        >
                          <span style={{ marginRight: "1%", flexGrow: 1 }}>
                            {file.name}
                          </span>
                          <Button
                            icon="pi pi-times"
                            type="button"
                            className="p-button-rounded p-button-danger p-button-text"
                            onClick={() => {
                              const updatedFiles = [
                                ...formDataShipmentFILES.uploadedFileWorkLog,
                              ];
                              updatedFiles.splice(index, 1);
                              setFormDataShipmentFILES((prev) => ({
                                ...prev,
                                uploadedFileWorkLog: updatedFiles,
                              }));
                            }}
                            tooltip="Ukloni fajl"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      )
                    )}

                    <Button
                      label={t('ture.obrisiSve')}
                      onClick={() =>
                        setFormDataShipmentFILES((prev) => ({
                          ...prev,
                          uploadedFileWorkLog: [],
                        }))
                      }
                      className="p-button-text p-button-danger"
                      style={{ marginTop: "1rem" }}
                    />
                  </div>
                )}
              </div>
              <div className="col-12 md:col-6 testAreaRadniNalog">
                <label htmlFor="napomenaPlacanje">{t('ture.napomenaPlacanje')}:</label>
                <InputTextarea
                  id="napomenaPlacanje"
                  placeholder={t('ture.phPlacanjeNapomena')}
                  name="napomenaPlacanje"
                  value={formDataShipment.napomenaPlacanje}
                  onChange={handleChange}
                  rows={3}
                />
              </div>
            </div>
          </Card>
        )}

        {changeView == 6 && (
          <Card className="gridRadniNalozi">
            <div className="gridDokumenti">
            <div
              className="red1 firstDivDoc"
              style={{ alignItems: "center", width: "100%" }}
            >
              {/* Napomena zauzima levu stranu, ruta se otvara dugmetom desno —
                  mapi treba ceo ekran, pa živi u dijalogu a ne u tabu */}
              <div className="vozac-red">
                <div className="vozac-napomena">
                  <label htmlFor="napomenaZaVozaca">{t('ture.napomenaVozaca')}:</label>
                  <InputTextarea
                    id="napomenaZaVozaca"
                    name="napomenaZaVozaca"
                    value={formDataShipment.napomenaZaVozaca}
                    onChange={handleChange}
                    rows={4}
                  />
                </div>

                <div className="vozac-mapa">
                  {izabranRadni && idWorkLog ? (
                    <RutaVozaca idWorkLog={idWorkLog} token={auth.token} toast={toast} />
                  ) : (
                    <div className="ruta-prazno">{t('ruta.nemaNaloga')}</div>
                  )}
                </div>
              </div>

              {izabranRadni && idWorkLog && statusVozacaInfo && (
                <div className="col-12 ruta-status">
                  <span><b>{t('ruta.statusVozaca')}:</b> {statusVozacaInfo.StatusVozacOpis || t('ruta.nemaStatusa')}</span>
                  <span><b>{t('ruta.statusRute')}:</b> {statusVozacaInfo.StatusRuteOpis || t('ruta.nemaStatusa')}</span>
                  {statusVozacaInfo.kretanje_pocetak && (
                    <span><b>{t('ruta.krenuo')}:</b> {new Date(statusVozacaInfo.kretanje_pocetak).toLocaleString("sr-RS")}</span>
                  )}
                  {statusVozacaInfo.kretanje_kraj && (
                    <span><b>{t('ruta.zavrsio')}:</b> {new Date(statusVozacaInfo.kretanje_kraj).toLocaleString("sr-RS")}</span>
                  )}
                </div>
              )}

              <div className="col-12">
                {izabranRadni && idWorkLog && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      padding: "0 1rem",
                      marginTop: "0.5rem",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        color: formDataShipment.objavljenoVozacu ? "#2e7d32" : "#757575",
                      }}
                    >
                      {formDataShipment.objavljenoVozacu
                        ? `${t('ture.objavljenoVozacu')}${formDataShipment.datumObjave ? " (" + new Date(formDataShipment.datumObjave).toLocaleString("sr-RS") + ")" : ""}`
                        : t('ture.nijeObjavljenoVozacu')}
                    </span>
                    {formDataShipment.objavljenoVozacu ? (
                      <Button
                        type="button"
                        label={t('ture.povuciObjavu')}
                        className="p-button-danger p-button-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => handleObjaviVozacu(false)}
                      />
                    ) : (
                      <Button
                        type="button"
                        label={t('ture.objaviVozacu')}
                        className="p-button-success p-button-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => handleObjaviVozacu(true)}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            </div>
          </Card>
        )}

        {/* ŠABLON — odloženo. Panel ide uz dugme gore, oba zakomentarisana.
        {changeView == 7 && (
          <Card className="gridRadniNalozi">
            <div className="gridDokumenti">
              <div
                className="red1 firstDivDoc"
                style={{ alignItems: "center", width: "100%" }}
              >
                <div className="col-12">
                  <h4 style={{ padding: "1rem" }}>{t('ture.sablonTab')}</h4>
                </div>
              </div>
            </div>
          </Card>
        )}
        */}

        {/* DOKUMENTA — samo prikaz: dokument je dokaz sta je zateceno na terenu,
            pa se iz TMS-a ne brise i ne menja. Brisanje postoji samo na telefonu,
            vozacu nad sopstvenim zapisom, dok nalog traje. */}
        {changeView == 8 && (
          <RnDokumenta idWorkLog={idWorkLog} brojNaloga={formDataShipment.radniNalog} />
        )}

        {/* Dugme unosa ide ispod svih tabova — u tabu VOZAČ prvo idu napomena
            i ruta, pa tek onda snimanje */}
        <div className="formUnosZap buttonUnosZap">
          <button
            type="submit"
            onClick={handleFormSubmit}
            className="btn btn-success"
          >
            {izabranRadni ? "SAČUVAJ" : "UNOS"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RadniNalog;
